module.exports = __webpack_public_path__ + "img/proyecto_home4.015a0cb2.png";